import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import Card, { CardProps } from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SxStyle } from '../../../../types';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  card: {
    padding: 4,
  },
};

interface Props extends CardProps {
  title?: string;
  label?: string;
  cardStyle?: SxProps<Theme>;
}

const PollCard = ({ title, label, children, cardStyle, ...props }: Props) => {
  const cardStyles = { ...styles.card, ...cardStyle };
  return (
    <Card sx={cardStyles} variant="outlined">
      <Stack spacing={4}>
        <Box>
          {title && <Typography variant="body1-bold">{title}</Typography>}
          {label && (
            <Typography component="p" variant="caption" color="textSecondary">
              {label}
            </Typography>
          )}
        </Box>
        {children}
      </Stack>
    </Card>
  );
};

export default PollCard;
